import DgValidatePasswordForm from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgValidatePasswordForm.install = function (Vue) {
  Vue.component(DgValidatePasswordForm.name, DgValidatePasswordForm)
}
export default DgValidatePasswordForm

export { DgValidatePasswordForm }